if (!customElements.get('product-form')) {
  const stitchingSelector = '[field-name="Do you want to stitch"][data-variant-product="8857027215574"][data-variant-id]';
  const overlappingStitching = ['46512641048790', '46512641016022'];
  // Avis intercepts accelerated checkout at document capture. Validate once at
  // window capture so stale paid selections cannot reach any app cart handler.
  window.addEventListener('click', (event) => {
    const option = event.target?.closest?.(`input[type="checkbox"]${stitchingSelector}`);
    if (option?.checked && !option.disabled && overlappingStitching.includes(option.dataset.variantId)) {
      const scope = option.closest('product-info') || option.closest('form');
      // Ready to wear includes fall and edging. Keep the shopper's latest
      // choice and let the app's native click/change handlers remove the other.
      scope?.querySelectorAll(stitchingSelector).forEach((other) => {
        if (other !== option && other.checked && !other.disabled &&
            overlappingStitching.includes(other.dataset.variantId) &&
            other.dataset.variantId !== option.dataset.variantId) other.click();
      });
    }
    const button = event.target?.closest?.('.avis-new-addcart-button, .avis-checkout');
    const productForm = button?.closest('product-form');
    if (!productForm?.stitchingState) return;
    const state = productForm.stitchingState();
    if (state.error) {
      event.preventDefault();
      event.stopImmediatePropagation();
      productForm.handleErrorMessage(state.error);
    }
  }, true);

  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        // Another options/validation handler may already own this submission.
        if (evt.defaultPrevented) return;
        evt.preventDefault();
        if (this.stitchingRedirecting) return;
        const stitching = this.stitchingState();
        if (stitching.error) {
          this.handleErrorMessage(stitching.error);
          return;
        }
        if (stitching.button) {
          // Enter/requestSubmit must use the same atomic saree + service app
          // request as a mouse click. Never send a second, single-item request.
          this.handleErrorMessage();
          this.stitchingRedirecting = true;
          try {
            stitching.button.click();
          } finally {
            this.stitchingRedirecting = false;
          }
          return;
        }
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productForm: this,
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productForm: this,
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      stitchingState() {
        const scope = this.closest('product-info') || this.form;
        const controls = Array.from(scope.querySelectorAll(stitchingSelector));
        const selected = controls.filter(input => input.checked && !input.disabled);
        const property = this.form.querySelector('[name="properties[Do you want to stitch]"]');
        const productId = this.form.querySelector('[name="product-id"]')?.value;
        const mainProductId = window.ap_front_settings?.product_info?.product?.id;
        const active = window.avisAddChargeActive?.[productId]?.activeVariants ||
          (String(mainProductId) === productId ? window.avisAddChargeActive?.default?.activeVariants : null);
        const paid = Object.values(active || {}).filter(item => item.isShow && String(item.productId) === '8857027215574');
        const button = this.form.querySelector('.avis-new-addcart-button');
        const retry = 'Your stitching selection is still updating. Please select it again and add to cart once its price appears.';
        const hasStitching = selected.length || paid.length || (!property?.disabled && property?.value?.trim());
        const deliveryEstimate = this.form.querySelector('[name="properties[Estimated Arrival date.]"]');
        // The generic delivery app does not include custom preparation time.
        // Omit that estimate from stitched orders; restore only our own disable.
        if (deliveryEstimate) {
          if (hasStitching && !deliveryEstimate.disabled) {
            deliveryEstimate.dataset.muralikaStitchingEtaDisabled = 'true';
            deliveryEstimate.disabled = true;
          } else if (!hasStitching && deliveryEstimate.dataset.muralikaStitchingEtaDisabled === 'true') {
            delete deliveryEstimate.dataset.muralikaStitchingEtaDisabled;
            deliveryEstimate.disabled = false;
          }
        }

        if (overlappingStitching.every(id => selected.some(input => input.dataset.variantId === id))) {
          return { error: 'Ready to wear already includes fall and edging. Please select either Ready to wear or Fall and Edging.' };
        }
        if (!selected.length) {
          // Preserve the user's choice if a section/app refresh lost its UI.
          if ((!property?.disabled && property?.value?.trim()) || paid.length) return { error: retry };
          return {};
        }
        if (!productId || !active || paid.length !== selected.length ||
            !selected.every(input => {
              const item = active[input.dataset.variantString];
              return item?.isShow && String(item.productId) === '8857027215574' &&
                String(item.variantId) === input.dataset.variantId;
            }) || window.AvisOptionsConfig?.priceMod?.isCloneButtonAddCart !== true || !button) {
          return { error: retry };
        }
        if (button.disabled || button.getAttribute('aria-disabled') === 'true' ||
            button.classList.contains('loading') || button.classList.contains('apo-loading')) {
          return { error: 'Your saree and stitching selection are being added. Please wait before trying again.' };
        }
        return { button };
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
